// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2DsVW","label":"Category_label__3hlOY","content":"Category_content__3bO_2","header":"Category_header__2b3HY","location":"Category_location__2qfAS"};